export default {"src":"/_next/static/media/ic-logout.d6031d71.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};